import type { ApiError } from "@/lib/api";
import { api } from "@/lib/api";
import type { ProviderConnection, UserProfile } from "@/types";

export async function getCurrentUserProfile(): Promise<{
  data: UserProfile | null;
  error: ApiError | null;
}> {
  return api.get<UserProfile>("/profiles/me");
}

export async function getWeeklyStepTotal(): Promise<{ data: number; error: ApiError | null }> {
  const res = await api.get<number>("/steps/weekly");
  if (res.error) return { data: 0, error: res.error };
  return { data: res.data ?? 0, error: null };
}

export async function getProviderConnections(): Promise<{
  data: ProviderConnection[] | null;
  error: ApiError | null;
}> {
  const res = await api.get<ProviderConnection[]>("/provider-connections");
  if (res.error) return { data: null, error: res.error };
  return { data: res.data ?? [], error: null };
}
